// components/ComponentLoader.js
import React from "react";
import "./ComponentLoader.css";

const ComponentLoader = () => (
  <div className="component-loader">
    <div className="wave-container">
      <span className="wave" />
      <span className="wave" />
      <span className="wave" />
      <span className="wave" />
      <span className="wave" />
    </div>
  </div>
);

export default ComponentLoader;
